module.exports = __webpack_public_path__ + "media/src/images/dandori/counter-5c077c2b0b3f841edeffd13602b27771.png";